/**
 * Inicializa el token getter de axios.
 * Usa authSessionService (Cognito + verifyInactivityTime).
 */
import { setTokenGetter } from "./axiosInstance";
import { authSessionService } from "features/auth/services/authSessionService";

export function initAxiosTokenGetter(): void {
    setTokenGetter(async () => {
        if (authSessionService.userIsLoggedIn()) {
            await authSessionService.verifyInactivityTime();
        }
        return await authSessionService.getAccessToken();
    });
}
